import styled, { css } from 'styled-components'

export const ScaleBadge = styled.button`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    min-width: 3.25rem;
    height: 1.5rem;
    margin: 0 0.1rem;
    padding: 0 0.5rem;
    border: none;
    border-radius: 0.4rem;
    background: ${theme.colors.white};
    color: ${theme.colors.dark};
    font-family: inherit;
    font-size: 0.7rem;
    font-weight: 600;
    font-variant-numeric: tabular-nums;
    cursor: pointer;
    user-select: none;
  `}
`
